module.exports = __webpack_public_path__ + "img/neo-burger-white-icon.1b63a5cd.svg";